import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const AMLListState = atom<boolean>({
  key: 'AMLListState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
